module.exports = __webpack_public_path__ + "img/cluevo_readyCheck.5892e0aa.svg";